import { makeStyles } from "@mui/styles";
export default makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    position: "relative",
  },
  root: {
    flexGrow: 1,
  },
}));
